import { useCallback, useEffect, useState } from 'react';
import { getApiErrorMessage } from '../../utils/httpError';
import { getPurchasePlans } from './purchaseApi';
import { normalizePurchasePlans } from './purchasePlans';

const LOAD_ERROR = 'Unable to load purchase plans. Please try again.';

export default function usePurchasePlans() {
  const [plans, setPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setErrorMessage('');

    getPurchasePlans()
      .then((response) => {
        if (cancelled) return;
        const nextPlans = normalizePurchasePlans(response.data);
        setPlans(nextPlans);
        if (nextPlans.length === 0) setErrorMessage('No purchase plans are available right now.');
      })
      .catch((error) => {
        if (cancelled) return;
        setPlans([]);
        setErrorMessage(getApiErrorMessage(error, LOAD_ERROR));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [reloadToken]);

  const reload = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  return { plans, isLoading, errorMessage, reload };
}
